var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.11538C16.5 5.80936 16.3784 5.51588 16.162 5.29949C15.9457 5.0831 15.6522 4.96154 15.3462 4.96154H13.0385V2.65385C13.0385 2.34783 12.9169 2.05434 12.7005 1.83795C12.4841 1.62157 12.1906 1.5 11.8846 1.5H2.65385C2.34783 1.5 2.05434 1.62157 1.83796 1.83795C1.62157 2.05434 1.5 2.34783 1.5 2.65385V11.8846C1.49969 11.9939 1.5308 12.1009 1.58962 12.1929C1.64843 12.285 1.73248 12.3582 1.83173 12.4038C1.9083 12.4407 1.99197 12.4604 2.07693 12.4615C2.20871 12.4624 2.33652 12.4164 2.4375 12.3317L4.96154 10.2981V12.4615C4.96154 12.7676 5.08311 13.061 5.29949 13.2774C5.51588 13.4938 5.80937 13.6154 6.11539 13.6154H12.8654L15.5625 15.7933C15.6458 15.8623 15.7473 15.9058 15.8548 15.9186C15.9622 15.9314 16.0711 15.9129 16.1683 15.8654C16.2675 15.8197 16.3516 15.7465 16.4104 15.6545C16.4692 15.5624 16.5003 15.4554 16.5 15.3462V6.11538ZM4.57212 9.12981L2.65385 10.6731V2.65385H11.8846V9H4.93269C4.80091 8.99911 4.6731 9.04512 4.57212 9.12981ZM13.4279 12.5913C13.3269 12.5067 13.1991 12.4606 13.0673 12.4615H6.11539V10.1538H11.8846C12.1906 10.1538 12.4841 10.0323 12.7005 9.81589C12.9169 9.5995 13.0385 9.30602 13.0385 9V6.11538H15.3462V14.1346L13.4279 12.5913Z",
    fill: "white",
    fillOpacity: 0.74
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessaging);
export default __webpack_public_path__ + "static/media/messaging.35ef59b62808206cc875dd8aa015e518.svg";
export { ForwardRef as ReactComponent };